'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faArrowUpFromLine,
  faCaretDown,
  faSeedling,
  faWavePulse,
} from '@fortawesome/pro-solid-svg-icons';
import { faFilter, faUserCircle } from '@fortawesome/pro-regular-svg-icons';
import { useDrawer } from 'src/hooks/drawers/useDrawer';

const AnalyticsDrawer = () => {
  const { closeAllButCurrent, closeDrawer, isDrawerOpen } = useDrawer();

  const handleToggleDrawer = () => {
    if (isDrawerOpen('analytics-drawer')) {
      closeDrawer('analytics-drawer');
    } else {
      closeAllButCurrent('analytics-drawer');
    }
  };

  return (
    <div
      className={`self-stretch inline-flex flex-col justify-start items-start transform transition-all duration-300 ease-in-out h-full ${
        isDrawerOpen('analytics-drawer') ? 'w-128' : 'w-16'
      }`}
    >
      {/* Drawer Header */}
      <div
        className="self-stretch h-16 w-full px-6 py-4 bg-white inline-flex justify-between items-center gap-2 hover:bg-neutral-100 rounded cursor-pointer"
        onClick={handleToggleDrawer}
      >
        <div
          className={`flex-1 justify-start text-primary text-lg font-bold font-['Inter'] leading-7 ${
            isDrawerOpen('analytics-drawer') ? 'flex' : 'hidden'
          } `}
        >
          California South
        </div>
        <div
          className="w-5 h-5 flex justify-center items-center "
          onClick={handleToggleDrawer}
        >
          <Icon
            icon={faArrowUpFromLine}
            size="lg"
            className={`w-4 h-3 text-secondary transition-all duration-300 ${
              isDrawerOpen('analytics-drawer') ? 'rotate-90' : '-rotate-90'
            }`}
          />
        </div>
      </div>
      {/* Drawer Content */}
      <div
        className={`self-stretch px-6 py-4 bg-neutral-050 border-t border-neutral-200 inline-flex flex-col justify-start items-start gap-4 ${
          isDrawerOpen('analytics-drawer') ? 'flex' : 'hidden'
        }`}
      >
        <div className="self-stretch inline-flex justify-between items-center">
          <div className="flex justify-start items-center gap-1">
            <div className="w-5 h-5 flex items-center justify-center">
              <Icon icon={faUserCircle} className="w-4 h-4 text-secondary" />
            </div>
            <div className="text-center justify-start text-primary text-sm font-normal font-['Inter'] leading-tight">
              John Smith
            </div>
          </div>
          {/* Export dropdown */}
          <div className="h-8 inline-flex flex-col justify-center items-center gap-1">
            <div className="self-stretch px-4 py-2 bg-white rounded-[99px] border border-neutral-200 inline-flex justify-start items-center gap-2">
              <div className="flex justify-start items-center gap-2">
                <div className="justify-start text-primary text-xs font-normal font-['Inter'] leading-none">
                  Export
                </div>
                <Icon icon={faCaretDown} className="text-neutral-500" />
              </div>
            </div>
          </div>
        </div>
        {/* Analytic Information */}
        <div className="self-stretch flex flex-col justify-start items-start gap-4">
          <div className="self-stretch inline-flex justify-start items-start gap-4">
            <div className="flex-1 p-4 bg-white rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.00)] outline outline-1 -outline-offset-1 outline-neutral-300 inline-flex flex-col justify-start items-start gap-2">
              <div className="self-stretch flex flex-col justify-start items-start">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-secondary text-xs font-semibold font-['Inter'] leading-none">
                    Total Addressable Market
                  </div>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <Icon
                      icon={faWavePulse}
                      className="w-4 h-4 text-blue-400"
                    />
                  </div>
                </div>
                <div className="justify-start text-primary text-xl font-bold font-['Inter'] leading-7">
                  $328 Million
                </div>
              </div>
            </div>
            <div className="flex-1 p-4 bg-white rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.00)] outline outline-1 -outline-offset-1 outline-neutral-300 inline-flex flex-col justify-start items-start gap-2">
              <div className="self-stretch flex flex-col justify-start items-start">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-secondary text-xs font-semibold font-['Inter'] leading-none">
                    Market Growth Rate
                  </div>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <Icon
                      icon={faSeedling}
                      className="w-4 h-4 text-green-400"
                    />
                  </div>
                </div>
                <div className="inline-flex justify-start items-end gap-1">
                  <div className="justify-start text-primary text-xl font-bold font-['Inter'] leading-7">
                    12%
                  </div>
                  <div className="pb-1 flex justify-center items-center gap-2.5">
                    <div className="justify-start text-secondary text-xs font-normal font-['Inter'] leading-none">
                      Annual Growth
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch inline-flex justify-start items-start gap-4">
            <div className="flex-1 p-4 bg-white rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.00)] outline outline-1 -outline-offset-1 outline-neutral-300 inline-flex flex-col justify-start items-start gap-2">
              <div className="self-stretch flex flex-col justify-start items-start">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-secondary text-xs font-semibold font-['Inter'] leading-none">
                    Market Share
                  </div>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <Icon
                      icon={faSeedling}
                      className="w-4 h-4 text-fuchsia-400"
                    />
                  </div>
                </div>
                <div className="inline-flex justify-start items-end gap-1">
                  <div className="justify-start text-primary text-xl font-bold font-['Inter'] leading-7">
                    18%
                  </div>
                  <div className="pb-1 flex justify-center items-center gap-2.5">
                    <div className="justify-start text-secondary text-xs font-normal font-['Inter'] leading-none">
                      Current Customers
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-1 p-4 bg-white rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.00)] outline outline-1 -outline-offset-1 outline-neutral-300 inline-flex flex-col justify-start items-start gap-2">
              <div className="self-stretch flex flex-col justify-start items-start">
                <div className="self-stretch inline-flex justify-between items-center">
                  <div className="justify-start text-secondary text-xs font-semibold font-['Inter'] leading-none">
                    Pipeline Coverage
                  </div>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <Icon icon={faFilter} className="w-4 h-4 text-orange-400" />
                  </div>
                </div>
                <div className="inline-flex justify-start items-end gap-1">
                  <div className="justify-start text-primary text-xl font-bold font-['Inter'] leading-7">
                    35%
                  </div>
                  <div className="pb-1 flex justify-center items-center gap-2.5">
                    <div className="justify-start text-secondary text-xs font-normal font-['Inter'] leading-none">
                      Available Market
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="self-stretch bg-white rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.00)] outline outline-1 -outline-offset-1 outline-neutral-300 flex flex-col justify-start items-start overflow-hidden">
          <div className="self-stretch p-4 border-b border-neutral-300 inline-flex justify-between items-center">
            <div className="justify-start text-primary text-base font-bold font-['Inter'] leading-normal">
              Map View
            </div>
            <div className="h-8 flex justify-start items-center gap-2">
              <div className="px-4 py-2 bg-white rounded-[99px] outline outline-1 -outline-offset-1 outline-neutral-300 flex justify-start items-center gap-2">
                <div className="flex justify-start items-center gap-2">
                  <div className="w-4 h-4 relative">
                    <div className="w-3.5 h-3.5 left-[1px] top-[1px] absolute bg-text-secondary" />
                  </div>
                  <div className="justify-start text-primary text-xs font-normal font-['Inter'] leading-none">
                    Open in Discovery
                  </div>
                </div>
              </div>
              <div className="px-4 py-2 bg-white rounded-[99px] outline outline-1 -outline-offset-1 outline-neutral-300 flex justify-start items-center gap-2">
                <div className="flex justify-start items-center gap-2">
                  <div className="w-4 h-4 bg-text-secondary" />
                  <div className="justify-start text-primary text-xs font-normal font-['Inter'] leading-none">
                    Manage Territory
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch h-64 p-4 inline-flex justify-start items-end gap-2.5">
            <div className="flex-1 flex justify-between items-end">
              <div className="inline-flex flex-col justify-start items-start gap-4">
                <div className="p-4 bg-white rounded-[99px] shadow-[0px_8px_8px_0px_rgba(0,0,0,0.08)] outline outline-1 -outline-offset-1 outline-neutral-300 flex flex-col justify-center items-center gap-4">
                  <div className="w-4 h-4 relative overflow-hidden">
                    <div className="w-3.5 h-4 left-[1px] top-0 absolute bg-orange-600" />
                  </div>
                </div>
                <div className="p-4 bg-white rounded-[99px] shadow-[0px_8px_8px_0px_rgba(0,0,0,0.08)] outline outline-1 -outline-offset-1 outline-neutral-300 flex flex-col justify-center items-start gap-4">
                  <div className="w-4 h-4 bg-text-secondary" />
                  <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                  <div className="w-4 h-4 relative">
                    <div className="w-4 h-0.5 left-0 top-[7px] absolute">
                      <div className="w-4 h-0.5 left-0 top-0 absolute bg-text-secondary" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-4 bg-white rounded-[99px] shadow-[0px_8px_8px_0px_rgba(0,0,0,0.08)] outline outline-1 -outline-offset-1 outline-neutral-300 inline-flex flex-col justify-center items-center gap-4">
                <div className="w-4 h-4 bg-text-secondary" />
              </div>
            </div>
          </div>
        </div>
        <div
          data-version="Trend"
          className="w-[536px] bg-white rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.00)] outline outline-1 -outline-offset-1 outline-neutral-300 flex flex-col justify-start items-start overflow-hidden"
        >
          <div className="self-stretch h-16 p-4 border-b border-neutral-300 inline-flex justify-start items-center gap-2">
            <div className="flex-1 justify-start text-primary text-base font-bold font-['Inter'] leading-normal">
              Volume Trends (Claims)
            </div>
          </div>
          <div className="self-stretch pt-4 flex flex-col justify-center items-center gap-2.5">
            <div className="h-8 pr-4 bg-white rounded-[99px] outline outline-1 -outline-offset-1 outline-neutral-300 inline-flex justify-start items-center gap-2">
              <div className="w-20 self-stretch px-3 bg-neutral-200 rounded-[99px] flex justify-center items-center gap-2.5">
                <div className="justify-start text-primary text-xs font-semibold font-['Inter'] leading-none">
                  Trend
                </div>
              </div>
              <div className="w-12 text-center justify-start text-primary text-xs font-normal font-['Inter'] leading-none">
                Total
              </div>
            </div>
          </div>
          <div className="self-stretch p-4 relative flex flex-col justify-center items-start">
            <div className="w-4 h-36 left-[479px] top-[56px] absolute opacity-30 bg-white overflow-hidden">
              <div className="w-72 h-64 left-[-84.93px] top-[99.91px] absolute origin-top-left -rotate-45 inline-flex justify-start items-start overflow-hidden">
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
                <div className="w-48 self-stretch relative bg-teal-100" />
                <div className="w-48 self-stretch relative bg-teal-200" />
              </div>
            </div>
            <div className="self-stretch px-6 pb-4 inline-flex justify-between items-start">
              <div className="flex justify-start items-center gap-4">
                <div className="flex justify-start items-center gap-4">
                  <div className="flex justify-start items-center gap-2">
                    <div
                      data-label="false"
                      data-state="Default"
                      data-status="Checked"
                      className="flex justify-start items-center gap-2"
                    >
                      <div className="w-4 h-4 relative bg-orange-400 rounded outline outline-1 -outline-offset-1 outline-neutral-300 overflow-hidden">
                        <div className="w-4 h-4 left-0 top-0 absolute overflow-hidden">
                          <div className="w-3 h-2 left-[2.40px] top-[4px] absolute bg-white" />
                        </div>
                      </div>
                    </div>
                    <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                      Elevated PSA
                    </div>
                  </div>
                </div>
                <div className="flex justify-start items-center gap-4">
                  <div className="flex justify-start items-center gap-2">
                    <div
                      data-label="false"
                      data-state="Default"
                      data-status="Checked"
                      className="flex justify-start items-center gap-2"
                    >
                      <div className="w-4 h-4 relative bg-indigo-400 rounded outline outline-1 -outline-offset-1 outline-neutral-300 overflow-hidden">
                        <div className="w-4 h-4 left-0 top-0 absolute overflow-hidden">
                          <div className="w-3 h-2 left-[2.40px] top-[4px] absolute bg-white" />
                        </div>
                      </div>
                    </div>
                    <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                      Prostate Biopsy
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-start items-center gap-2">
                <div className="w-4 h-4 relative opacity-60 bg-white rounded outline outline-1 -outline-offset-1 outline-neutral-300 overflow-hidden">
                  <div className="w-72 h-64 left-[-84.93px] top-[99.91px] absolute origin-top-left -rotate-45 inline-flex justify-start items-start overflow-hidden">
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                    <div className="w-48 self-stretch relative bg-teal-100" />
                    <div className="w-48 self-stretch relative bg-teal-200" />
                  </div>
                </div>
                <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                  Incomplete Data
                </div>
              </div>
            </div>
            <div className="self-stretch h-40 pr-6 inline-flex justify-start items-center">
              <div className="self-stretch pr-2 inline-flex flex-col justify-center items-center gap-2.5">
                <div className="origin-top-left -rotate-90 text-center justify-start text-secondary text-xs font-semibold font-['Inter'] leading-none">
                  Volume
                </div>
              </div>
              <div className="self-stretch pr-2 inline-flex flex-col justify-between items-end">
                <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                  20k
                </div>
                <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                  15k
                </div>
                <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                  10k
                </div>
                <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                  5k
                </div>
                <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                  0
                </div>
              </div>
              <div className="w-1 self-stretch py-2 inline-flex flex-col justify-between items-start">
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              </div>
              <div className="self-stretch py-2 flex justify-start items-center">
                <div className="w-36 self-stretch origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              </div>
              <div className="flex-1 self-stretch py-2 inline-flex flex-col justify-between items-start">
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              </div>
              <div className="self-stretch py-2 flex justify-start items-center gap-2.5">
                <div className="w-36 self-stretch origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              </div>
              <div className="flex-1 self-stretch py-2 inline-flex flex-col justify-between items-start">
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              </div>
              <div className="self-stretch py-2 flex justify-start items-center gap-2.5">
                <div className="w-36 self-stretch origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              </div>
              <div className="flex-1 self-stretch py-2 inline-flex flex-col justify-between items-start">
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              </div>
              <div className="self-stretch py-2 flex justify-start items-center gap-2.5">
                <div className="w-36 self-stretch origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              </div>
              <div className="flex-1 self-stretch py-2 inline-flex flex-col justify-between items-start">
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              </div>
              <div className="self-stretch py-2 flex justify-start items-center gap-2.5">
                <div className="w-36 self-stretch origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              </div>
              <div className="w-10 self-stretch py-2 inline-flex flex-col justify-between items-start">
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              </div>
              <div className="self-stretch py-2 flex justify-start items-center gap-2.5">
                <div className="w-36 self-stretch origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              </div>
            </div>
            <div className="self-stretch pl-8 pr-9 pt-2 inline-flex justify-between items-start">
              <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                1/1/2020
              </div>
              <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                1/1/2021
              </div>
              <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                1/1/2023
              </div>
              <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                1/1/2024
              </div>
              <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                1/1/2025
              </div>
            </div>
            <div className="self-stretch pt-2 inline-flex justify-center items-center gap-2.5">
              <div className="flex-1 text-center justify-start text-secondary text-xs font-semibold font-['Inter'] leading-none">
                Date
              </div>
            </div>
            <div className="w-96 h-20 left-[72.50px] top-[120.50px] absolute origin-top-left rotate-[-9.42deg] outline outline-2 -outline-offset-1 outline-orange-400" />
            <div className="w-96 h-16 left-[73px] top-[111.50px] absolute origin-top-left rotate-[-9.42deg] outline outline-2 -outline-offset-1 outline-indigo-400" />
          </div>
        </div>
        <div
          data-version="Payer Mix"
          className="self-stretch bg-white rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.00)] outline outline-1 -outline-offset-1 outline-neutral-300 flex flex-col justify-start items-start overflow-hidden"
        >
          <div className="self-stretch h-16 p-4 border-b border-neutral-300 inline-flex justify-start items-center">
            <div className="flex-1 justify-start text-primary text-base font-bold font-['Inter'] leading-normal">
              Payer Mix & Reimbursements
            </div>
          </div>
          <div className="self-stretch pt-4 flex flex-col justify-center items-center gap-2.5">
            <div className="w-48 h-8 pr-4 bg-white rounded-[99px] outline outline-1 -outline-offset-1 outline-neutral-300 inline-flex justify-start items-center gap-2">
              <div className="self-stretch px-3 bg-neutral-200 rounded-[99px] flex justify-center items-center gap-2.5">
                <div className="justify-start text-primary text-xs font-semibold font-['Inter'] leading-none">
                  Payer Mix
                </div>
              </div>
              <div className="text-center justify-start text-primary text-xs font-normal font-['Inter'] leading-none">
                Reimbursement
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col justify-center items-start">
            <div className="self-stretch p-4 border-b border-neutral-300 inline-flex justify-start items-center gap-4">
              <div className="flex-1 h-44 relative">
                <div className="w-40 h-40 left-[0.18px] top-[12px] absolute bg-indigo-500 rounded-[116.54px] inline-flex flex-col justify-center items-center gap-1">
                  <div className="justify-start">
                    <span className="text-common-White text-3xl font-bold font-['Inter'] leading-7">
                      55
                    </span>
                    <sup className="text-common-White text-3xl font-bold font-['Inter'] leading-7">
                      %
                    </sup>
                  </div>
                  <div className="justify-start text-common-White text-base font-semibold font-['Inter'] leading-normal">
                    Commercial
                  </div>
                </div>
                <div className="w-20 h-20 left-[160.18px] top-[39px] absolute bg-orange-500 rounded-[59.01px] inline-flex flex-col justify-center items-center gap-1">
                  <div className="justify-start">
                    <span className="text-common-White text-sm font-bold font-['Inter'] leading-none">
                      25
                    </span>
                    <sup className="text-common-White text-sm font-bold font-['Inter'] leading-none">
                      %
                    </sup>
                  </div>
                  <div className="justify-start text-common-White text-xs font-semibold font-['Inter'] leading-3">
                    Medicare
                  </div>
                </div>
                <div className="w-14 h-14 left-[147.18px] top-[115px] absolute bg-pink-500 rounded-[41.30px] inline-flex flex-col justify-center items-center gap-1">
                  <div className="justify-start">
                    <span className="text-common-White text-xs font-bold font-['Inter'] leading-[10.01px]">
                      15
                    </span>
                    <sup className="text-common-White text-xs font-bold font-['Inter'] leading-[10.01px]">
                      %
                    </sup>
                  </div>
                  <div className="justify-start text-common-White text-xs font-semibold font-['Inter'] leading-[8.34px]">
                    Medicaid
                  </div>
                </div>
                <div className="w-10 h-10 left-[142.18px] top-[9px] absolute bg-teal-500 rounded-[29.50px] inline-flex flex-col justify-center items-center gap-1">
                  <div className="justify-start">
                    <span className="text-common-White text-xs font-bold font-['Inter'] leading-[7.15px]">
                      5
                    </span>
                    <sup className="text-common-White text-xs font-bold font-['Inter'] leading-[7.15px]">
                      %
                    </sup>
                  </div>
                  <div className="justify-start text-common-White text-xs font-normal font-['Inter'] leading-[5.96px]">
                    Other
                  </div>
                </div>
              </div>
              <div className="w-44 self-stretch origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
              <div className="flex-1 pb-2 inline-flex flex-col justify-start items-start gap-4">
                <div className="self-stretch flex flex-col justify-start items-start gap-2">
                  <div className="text-right justify-start text-primary text-sm font-bold font-['Inter'] leading-tight">
                    Top 5 Payers
                  </div>
                  <div className="self-stretch pl-2 inline-flex justify-between items-start">
                    <div className="w-40 self-stretch flex justify-start items-center gap-2">
                      <div className="w-1 self-stretch bg-indigo-400 rounded" />
                      <div className="text-right justify-start text-secondary text-xs font-medium font-['Inter'] leading-none">
                        Aetna
                      </div>
                    </div>
                    <div className="text-right justify-start text-secondary text-xs font-medium font-['Inter'] leading-none">
                      8%
                    </div>
                  </div>
                  <div className="self-stretch pl-2 inline-flex justify-between items-start">
                    <div className="self-stretch flex justify-start items-center gap-2">
                      <div className="w-1 self-stretch bg-indigo-400 rounded" />
                      <div className="text-right justify-start text-secondary text-xs font-medium font-['Inter'] leading-none">
                        Blue Cross Blue Shield of Cal...
                      </div>
                    </div>
                    <div className="text-right justify-start text-secondary text-xs font-medium font-['Inter'] leading-none">
                      5%
                    </div>
                  </div>
                  <div className="self-stretch pl-2 inline-flex justify-between items-start">
                    <div className="w-40 self-stretch flex justify-start items-center gap-2">
                      <div className="w-1 self-stretch bg-orange-400 rounded" />
                      <div className="text-right justify-start text-secondary text-xs font-medium font-['Inter'] leading-none">
                        Cigna
                      </div>
                    </div>
                    <div className="text-right justify-start text-secondary text-xs font-medium font-['Inter'] leading-none">
                      3%
                    </div>
                  </div>
                  <div className="self-stretch pl-2 inline-flex justify-between items-start">
                    <div className="w-40 self-stretch flex justify-start items-center gap-2">
                      <div className="w-1 self-stretch bg-indigo-400 rounded" />
                      <div className="text-right justify-start text-secondary text-xs font-medium font-['Inter'] leading-none">
                        Humana
                      </div>
                    </div>
                    <div className="text-right justify-start text-secondary text-xs font-medium font-['Inter'] leading-none">
                      2%
                    </div>
                  </div>
                  <div className="self-stretch pl-2 inline-flex justify-between items-start">
                    <div className="w-48 self-stretch flex justify-start items-center gap-2">
                      <div className="w-1 self-stretch bg-indigo-400 rounded" />
                      <div className="text-right justify-start text-secondary text-xs font-medium font-['Inter'] leading-none">
                        Kaiser Permanente
                      </div>
                    </div>
                    <div className="text-right justify-start text-secondary text-xs font-medium font-['Inter'] leading-none">
                      1.5%
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          data-version="Total"
          className="self-stretch h-96 bg-white rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.00)] outline outline-1 -outline-offset-1 outline-neutral-300 flex flex-col justify-start items-start overflow-hidden"
        >
          <div className="self-stretch h-16 p-4 border-b border-neutral-300 inline-flex justify-start items-center">
            <div className="justify-start text-primary text-base font-bold font-['Inter'] leading-normal">
              Place of Service
            </div>
          </div>
          <div className="self-stretch p-4 flex flex-col justify-center items-start">
            <div className="self-stretch pb-4 flex flex-col justify-center items-center gap-2.5">
              <div className="h-8 pr-4 bg-white rounded-[99px] outline outline-1 -outline-offset-1 outline-neutral-300 inline-flex justify-start items-center gap-2">
                <div className="w-20 self-stretch px-3 bg-neutral-200 rounded-[99px] flex justify-center items-center gap-2.5">
                  <div className="justify-start text-primary text-xs font-semibold font-['Inter'] leading-none">
                    Total
                  </div>
                </div>
                <div className="w-12 text-center justify-start text-primary text-xs font-normal font-['Inter'] leading-none">
                  Trend
                </div>
              </div>
            </div>
            <div className="self-stretch flex flex-col justify-start items-start">
              <div className="self-stretch pr-6 inline-flex justify-start items-center">
                <div className="self-stretch pr-2 inline-flex flex-col justify-center items-center gap-2.5">
                  <div className="origin-top-left -rotate-90 text-center justify-start text-secondary text-xs font-semibold font-['Inter'] leading-none">
                    Place of Service
                  </div>
                </div>
                <div className="flex-1 h-40 inline-flex flex-col justify-start items-start gap-2">
                  <div className="self-stretch flex flex-col justify-start items-start gap-4">
                    <div className="self-stretch inline-flex justify-start items-center gap-2">
                      <div className="w-28 text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                        Office
                      </div>
                      <div className="flex-1 h-2 bg-indigo-400 rounded" />
                      <div className="justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                        45%
                      </div>
                    </div>
                    <div className="self-stretch inline-flex justify-start items-center gap-2">
                      <div className="w-28 text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                        Outpatient Hospital
                      </div>
                      <div className="w-48 h-2 bg-orange-400 rounded" />
                      <div className="justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                        25%
                      </div>
                    </div>
                    <div className="self-stretch inline-flex justify-start items-center gap-2">
                      <div className="w-28 text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                        Inpatient Hospital
                      </div>
                      <div className="w-24 h-2 bg-teal-400 rounded" />
                      <div className="justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                        10%
                      </div>
                    </div>
                    <div className="self-stretch inline-flex justify-start items-center gap-2">
                      <div className="w-28 text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                        ASC
                      </div>
                      <div className="w-16 h-2 bg-purple-400 rounded" />
                      <div className="justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                        8%
                      </div>
                    </div>
                    <div className="self-stretch inline-flex justify-start items-center gap-2">
                      <div className="w-28 text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                        Emergency Room
                      </div>
                      <div className="w-8 h-2 bg-yellow-400 rounded" />
                      <div className="justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                        5%
                      </div>
                    </div>
                  </div>
                  <div className="w-28 inline-flex justify-end items-center gap-1">
                    <div className="w-5 h-5 relative overflow-hidden">
                      <div className="w-3.5 h-3.5 left-[3px] top-[3px] absolute bg-sky-600" />
                    </div>
                    <div className="justify-start text-sky-600 text-xs font-medium font-['Inter'] leading-none">
                      Site
                    </div>
                  </div>
                </div>
              </div>
              <div className="self-stretch pl-36 pr-6 flex flex-col justify-start items-start">
                <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                <div className="self-stretch inline-flex justify-between items-start">
                  <div className="w-1 h-0 origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                  <div className="w-1 h-0 origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                  <div className="w-1 h-0 origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                  <div className="w-1 h-0 origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                  <div className="w-1 h-0 origin-top-left rotate-90 outline outline-1 outline-offset-[-0.50px] outline-neutral-300"></div>
                </div>
              </div>
            </div>
            <div className="self-stretch pl-36 pt-2 inline-flex justify-between items-start">
              <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                0
              </div>
              <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                50,000
              </div>
              <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                100,000
              </div>
              <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                150,000
              </div>
              <div className="text-right justify-start text-teritary text-xs font-medium font-['Inter'] leading-none">
                200,000
              </div>
            </div>
            <div className="self-stretch pl-36 pt-2 inline-flex justify-center items-center gap-2.5">
              <div className="text-center justify-start text-secondary text-xs font-semibold font-['Inter'] leading-none">
                Total Volume
              </div>
            </div>
          </div>
        </div>
        <div className="self-stretch h-px bg-neutral-050" />
      </div>
    </div>
  );
};

export default AnalyticsDrawer;
